export default "__VITE_ASSET__BQ8CU_bu__"